export class SetCheckoutSessionRequired {
  static readonly type = '[Vendor] Set checkout session required';
}
